"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fakerBr = exports.maskBr = exports.utilsBr = exports.validateBr = void 0;
var utils = require("./src/utils");
var validate_1 = require("./src/validate");
Object.defineProperty(exports, "validateBr", { enumerable: true, get: function () { return validate_1.validateBr; } });
var faker_1 = require("./src/faker");
var mask = require("./src/mask");
var mask_1 = require("./src/mask");
var placa_1 = require("./src/placa");
var estados_1 = require("./src/estados");
exports.utilsBr = __assign(__assign({}, utils), { MASKS: mask_1.MASKS,
    PLACAS_RANGE: placa_1.PLACAS_RANGE,
    ESTADOS: estados_1.ESTADOS });
exports.maskBr = mask.maskBr;
exports.fakerBr = faker_1.default;
//# sourceMappingURL=index.js.map